import { render, staticRenderFns } from "./DetalheComponent3.vue?vue&type=template&id=77c763b8&"
import script from "./DetalheComponent3.vue?vue&type=script&lang=js&"
export * from "./DetalheComponent3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports